import { css } from "@emotion/css";
import { Colors } from "@snapchat/snap-design-system";

export const menuLink = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${Colors.Gray.V50};

    &:focus {
        color: ${Colors.Black.V200};
        outline: 1px solid lightblue;
    }
`;
